<template>
  <div class="home-wrapper">
    <MyHeader />
    <router-view />
    <MyFooter v-show="isShow" />
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue'
import MyFooter from '@/components/MyFooter.vue'

export default {
  name: 'HomeView',
  components: {
    MyHeader,
    MyFooter,
  },
  data() {
    return {
      isShow: true,
    }
  },
  computed: {},
  created() {},
  mounted() {
    const height = document.body.clientHeight
    window.addEventListener('resize', () => {
      if (document.body.clientHeight < height) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    })
  },
  updated() {},
  methods: {},
}
</script>
<style scoped lang="less">
.home-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
